module.exports = __webpack_public_path__ + "static/media/260.81c868a4.svg";